import { UploadOutlined } from "@ant-design/icons";
import { Button, Upload } from "antd";
import type { UploadFile, UploadProps } from "antd";

interface DataType {
  setFileList: (files: UploadFile[]) => void;
  fileList: UploadFile[];
  name: string;
  validFormats?: string[];
  filesLimit?: number;
  multiple?: boolean;
  className?: string;
}
const CBFiles = (props: DataType) => {
  const {
    fileList,
    setFileList,
    validFormats,
    name,
    filesLimit: maxCount,
    multiple,
    className,
  } = props;
  const validateFile = (file: UploadFile) => {
    let isValid = true;
    if (validFormats && validFormats.length > 0) {
      isValid = validFormats.includes(file?.type || "");
    }
    return isValid;
  };
  const uploadProps: UploadProps = {
    name,
    onRemove: (file) => {
      const index = fileList.indexOf(file);
      const newFileList = fileList.slice();
      newFileList.splice(index, 1);
      setFileList(newFileList);
    },
    beforeUpload: () => {
      return false;
    },
    onChange: (upload: { fileList?: UploadFile[]; file?: UploadFile }) => {
      const files = Array.isArray(upload.fileList)
        ? upload.fileList
        : [upload.file];
      let newFiles: UploadFile[] = [];
      if (files.length) {
        files.forEach((item) => {
          if (item instanceof File) {
            if (item && validateFile(item)) {
              newFiles.push(item as UploadFile);
            }
          } else {
            if (item?.originFileObj && validateFile(item.originFileObj)) {
              newFiles.push(item.originFileObj as UploadFile);
            }
          }
        });
        return setFileList(newFiles);
      }
    },
    fileList,
    maxCount,
    multiple,
  };

  return (
    <div className={className}>
      <Upload {...uploadProps}>
        <Button className="mb-2" icon={<UploadOutlined />}>
          Select File
        </Button>
      </Upload>
    </div>
  );
};

export default CBFiles;
